const QUOTE_NOT_SUPPORTED = 'error.quote.notSupported'

export { QUOTE_NOT_SUPPORTED }
